module.exports = __webpack_public_path__ + "images/category_lp/jewel/new/store_images/1_acd76a606d7c92a86baacba243a0849b.png";